module.exports = __webpack_public_path__ + "media/audio25.6b3a821d.mp3";